import { matchPath, useLocation } from 'react-router';


export const useMatchedRoute = (paths: string[]) => {
  const location = useLocation();

  return paths.findIndex(path => matchPath(path, location.pathname));
};
